<template>
  <div style="position:relative">
    <div class="searchDiv">
      <a-input-search style="margin-bottom: 8px" placeholder="请输入关键字" @change="onChangeInput" class="inputSearch"/>
      <a-button type="primary" @click="submit" v-if="$auth('role.configDeptJurisdiction')" :loading="btnLoading">保存</a-button>
      <a-button style="margin:0 10px" @click="initialize">初始化</a-button>
    </div>
    <a-spin :spinning="loading">
      <a-checkbox v-model="checkAll" @change="changeCheckAll" style="margin-bottom: 16px;margin-top: 6px;">
        全部
      </a-checkbox>
      <div ref="box" style="height:100%;overflow:auto;">
        <a-checkbox-group v-model="checkedList" :options="plainOptions" @change="onChange" />
      </div>
    </a-spin>
  </div>
</template>

<script>
import {
  getDeptEquiPermission,
  getDeptHasBeenConfigured,
  upDataDeptEquiPermission
} from '@/api/centralizedDeptManagement'

export default {
  async mounted () {
    await this.initTree()
  },
  data () {
    return {
      loading: false,
      btnLoading: false,
      // 多选列表
      plainOptions: [],
      plainOptionsOriginal: [],
      // 多选
      checkedList: [],
      checkedOldList: [],
      searchChecked: [],
      checkAll: false
    }
  },
  computed: {
    roleId () {
      return this.$store.state.role.roleId
    },
    roleName () {
      return this.$store.state.role.roleName
    }
  },
  watch: {
    roleId (id) {
      this.$nextTick(() => {
        this.$refs.box.scrollTop = 0
        this.initTree()
      })
    }
  },
  methods: {
    // 树结构
    async initTree () {
      this.loading = true
      getDeptHasBeenConfigured().then(res => {
        if (res.status === 0) {
          this.plainOptions = res.data.map(item => {
            return {
              label: item.departmentname + '[' + item.subcompanyname + ']',
              value: item.deptId
            }
          })
          this.plainOptionsOriginal = JSON.parse(JSON.stringify(this.plainOptions))
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
      const data = {
        roleId: this.roleId
      }
      getDeptEquiPermission(data).then(res => {
        if (res.status === 0) {
          this.checkedList = res.data.map(item => item.deptId)
          this.checkedOldList = JSON.parse(JSON.stringify(this.checkedList))
          this.changeSearchChecked()
          this.checkAll = this.plainOptions.length > 0 ? this.checkedList.length === this.plainOptions.length : false
          this.loading = false
        } else {
          this.loading = false
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error(err.info.message)
        })
    },
    // 搜索框回调
    onChangeInput (e) {
      const value = e.target.value
      if (value) {
        const result = this.plainOptionsOriginal.filter(item => item.label.indexOf(value) > -1)
        this.plainOptions = result
      } else {
        this.plainOptions = this.plainOptionsOriginal
      }
      this.changeSearchChecked()
      let bol = true
      this.plainOptions.forEach(item => {
        if (this.checkedList.indexOf(item.value) === -1) {
          bol = false
        }
      })
      this.checkAll = this.plainOptions.length > 0 ? bol : false
    },
    // 改变searchChecked
    changeSearchChecked () {
      this.searchChecked = []
      this.plainOptions.forEach(item => {
        if (this.checkedOldList.indexOf(item.value) > -1) {
          this.searchChecked.push(item.value)
        }
      })
    },
    // 去重
    deleteRepetition (arr) {
      const newArr = []
      for (const item of arr) {
        if (newArr.indexOf(item) === -1) {
          newArr.push(item)
        }
      }
      return newArr
    },
    // 多选回调
    onChange (checkedList) {
      if (this.searchChecked.length > 0) {
        const delList = []
        this.searchChecked.forEach(item => {
          if (checkedList.indexOf(item) === -1) {
            delList.push(item)
          }
        })
        delList.forEach(item => {
          const index = this.checkedOldList.indexOf(item)
          if (index > -1) {
            this.checkedOldList.splice(index, 1)
          }
        })
        this.checkedList = JSON.parse(JSON.stringify(this.deleteRepetition(this.checkedOldList.concat(checkedList))))
        this.checkedOldList = JSON.parse(JSON.stringify(this.checkedList))
        this.changeSearchChecked()
      } else {
        this.checkedList = JSON.parse(JSON.stringify(this.deleteRepetition(this.checkedOldList.concat(checkedList))))
        this.checkedOldList = JSON.parse(JSON.stringify(this.checkedList))
        this.changeSearchChecked()
      }
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    // 全选
    changeCheckAll (e) {
      if (e.target.checked) {
        this.plainOptions.forEach(item => {
          if (this.checkedList.indexOf(item.value) === -1) {
            this.checkedList.push(item.value)
          }
        })
      } else {
        this.plainOptions.forEach(item => {
          const index = this.checkedList.indexOf(item.value)
          if (index > -1) {
            this.checkedList.splice(index, 1)
          }
        })
      }
      this.checkedOldList = JSON.parse(JSON.stringify(this.checkedList))
      this.changeSearchChecked()
    },
    // 保存
    async submit () {
      const data = {
        roleId: this.roleId,
        deptEquiList: this.checkedList.map(item => {
          return {
            deptId: item
          }
        })
      }
      this.btnLoading = true
      upDataDeptEquiPermission(data).then(res => {
        if (res.status === 0) {
          this.$message.success('保存成功')
          this.btnLoading = false
        } else {
          this.$message.error(res.info.message)
          this.btnLoading = false
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
          this.btnLoading = false
        })
    },
    // 初始化
    initialize () {
      this.plainOptions = this.plainOptionsOriginal
      this.checkedList = []
      this.checkedOldList = []
      this.searchChecked = []
      this.checkAll = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-tree.ant-tree-icon-hide {
  overflow-y: visible !important;
}
.searchDiv {
  .inputSearch {
    width: 300px;
    margin-right: 20px;
  }
}
/deep/.ant-checkbox-group {
  display: grid;
  grid-template-columns: repeat(6, calc((100% - 140px )/ 6));
  grid-column-gap: 28px;
  grid-row-gap: 16px;
  .ant-checkbox-group-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    .ant-checkbox {
      margin-top: 2px;
    }
    >span:nth-child(2) {
      width: calc(100% - 22px);
      display: inline-block;
    }
  }
}
</style>
